import * as React from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	getWorkOrderBasePriorityBackgroundColor,
	dateFormatter,
	STOPLIGHT_COLORS,
	BLACKS_AND_WHITES,
	DATE_ONLY_FORMAT,
} from '../../utils/DataFormatterUtils';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import { ROLE_TYPES } from '../../utils/DataConstants';
import WorkOrderStatusDisplay from '../work_order_status_display/WorkOrderStatusDisplay';
import { Link } from 'react-router-dom';

require('./ServiceCallPopoverDisplay.less');

export const ServiceCallPopoverDisplayV2: React.FC<any> = ({ workOrder }) => {
	console.log('workOrder', workOrder);
	if (!workOrder) {
		return null;
	}

	let categoryBackgroundColor;
	switch (nullSafeGet('displayStatus', workOrder)) {
		case 'Pending':
			categoryBackgroundColor = '#4a1e87';
			break;
		case 'Open':
			categoryBackgroundColor = STOPLIGHT_COLORS.pureRed;
			break;
		case 'InProgress':
			categoryBackgroundColor = 'rgb(11, 28, 111)';
			break;
		case 'OnHold':
			categoryBackgroundColor = 'rgb(137, 107, 12)';
			break;
		case 'Completed':
			categoryBackgroundColor = STOPLIGHT_COLORS.pureGreen;
			break;
		case 'Cancelled':
			categoryBackgroundColor = BLACKS_AND_WHITES.blackPrimary;
			break;
		default:
			categoryBackgroundColor = BLACKS_AND_WHITES.blackPrimary;
	}
	return (
		<div className="serviceCallPopoverDisplay__row">
			<div className="serviceCallPopoverDisplay__bodyWrapper">
				<div
					className="materialCard__primaryTitle materialCard__flexCentVert"
					style={{ margin: 0, paddingTop: 8, paddingBottom: 8, alignItems: 'flex-start' }}
				>
					<div
						className="serviceCallPopoverDisplay__iconLabel"
						style={{
							height: 36,
							marginRight: 16,
							marginTop: 5,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'flex-start',
						}}
					>
						<div
							style={{
								background: categoryBackgroundColor,
								height: 17,
								width: 17,
								borderRadius: 5,
							}}
						></div>
					</div>
					<div>
						<Link to={`/supplier/workOrders/detail/${nullSafeGet('id', workOrder)}/details`}>
							<h5
								style={{
									marginBottom: 4,
									lineHeight: 1.3,
								}}
							>
								{nullSafeGet('title', workOrder)}
							</h5>
						</Link>
						{dateFormatter(
							nullSafeGet('lastServiceCall.serviceScheduledAt', workOrder),
							'dddd, MMMM D'
						)}{' '}
						at{' '}
						{dateFormatter(nullSafeGet('lastServiceCall.serviceScheduledAt', workOrder), 'h:mm a')}
					</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-location-logo-2`} />
					</div>
					<div className="serviceCallPopoverDisplay__text">
						{nullSafeGet('location.name', workOrder)}
					</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-company-2`} />
					</div>
					<div className="serviceCallPopoverDisplay__text">
						{nullSafeGet('supplierFacility.displayName', workOrder)}
					</div>
				</div>
				{nullSafeGet('lastServiceCall.leadTechnicianEmailContact.nameGiven', workOrder) ? (
					<div
						className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
						style={{ paddingTop: 8, paddingBottom: 8 }}
					>
						<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
							<i style={{ fontSize: 20 }} className={`icons8-font icons8-worker`} />
						</div>
						<div className="serviceCallPopoverDisplay__text">
							{nullSafeGetOrElse('lastServiceCall.additionalTechnicians', workOrder, []).length >
							0 ? (
								<div style={{ marginBottom: 8 }}>
									{nullSafeGetOrElse('lastServiceCall.additionalTechnicians', workOrder, [])
										.length + 1}{' '}
									technicians
								</div>
							) : null}
							{nullSafeGet('lastServiceCall.leadTechnicianEmailContact', workOrder) ? (
								<div
									className="materialCard__primaryTitle"
									style={{
										marginBottom: 0,
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<ContactAvatar
										size="small"
										hidePopover={true}
										style={{ marginRight: 8 }}
										contact={nullSafeGet('lastServiceCall.leadTechnicianEmailContact', workOrder)}
										userType={ROLE_TYPES.BUYER}
									/>
									<div>
										{nullSafeGet('lastServiceCall.leadTechnicianEmailContact.nameGiven', workOrder)}{' '}
										{nullSafeGet(
											'lastServiceCall.leadTechnicianEmailContact.nameFamily',
											workOrder
										)}
									</div>
								</div>
							) : null}
							{nullSafeGet('lastServiceCall.additionalTechnicians', workOrder).map((contact) => (
								<div
									className="materialCard__primaryTitle"
									style={{
										marginBottom: 0,
										display: 'flex',
										alignItems: 'center',
									}}
								>
									<ContactAvatar
										size="small"
										hidePopover={true}
										style={{ marginRight: 8 }}
										contact={contact}
										userType={ROLE_TYPES.BUYER}
									/>
									<div>
										{contact.nameGiven} {contact.nameFamily}
									</div>
								</div>
							))}
						</div>
					</div>
				) : null}
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-engineer-symbol`} />
					</div>
					<div className="serviceCallPopoverDisplay__text">
						{nullSafeGet('problemType.hierarchyName', workOrder)}
					</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-service-bell`} />
					</div>
					<div
						style={{
							color: getWorkOrderBasePriorityBackgroundColor(nullSafeGet('woPriority', workOrder)),
						}}
					>
						{nullSafeGet('woPriority.name', workOrder)}
					</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-track-order`} />
					</div>
					<div className="serviceCallPopoverDisplay__text">
						<WorkOrderStatusDisplay
							className="serviceCallsDetailPage__subtitle"
							status={nullSafeGet('status', workOrder)}
							displayStatus={nullSafeGet('displayStatus', workOrder)}
						/>
					</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className={`icons8-font icons8-search-button`} />
					</div>
					<div className="serviceCallPopoverDisplay__text">WO #{nullSafeGet('id', workOrder)}</div>
				</div>
				<div
					className="serviceCallPopoverDisplay__text materialCard__supportingText materialCard__flexCentVert"
					style={{ paddingTop: 8, paddingBottom: 8 }}
				>
					<div className="serviceCallPopoverDisplay__text serviceCallPopoverDisplay__iconLabel">
						<i style={{ fontSize: 20 }} className="icons8-font icons8-green-check-mark"></i>
					</div>
					<div className="serviceCallPopoverDisplay__text">
						Est. Completion{' '}
						{dateFormatter(
							nullSafeGetOrElse(
								'estimatedCompletionDate',
								workOrder,
								nullSafeGet('dueDate', workOrder)
							),
							DATE_ONLY_FORMAT
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
